import {WithSummaryModel} from '../../../../../common/entity/dto/plain/withSummary.model';
import {ConsultationCategorySummaryModel} from './consultationCategorySummary.model';
import {ConsultationCategoryExamDefinitionModel} from "./consultationCategoryExamDefinition.model";
import {ConsultationCategoryTreatmentDefinitionModel} from "./consultationCategoryTreatmentDefinition.model";

export class ConsultationCategoryModel extends WithSummaryModel<ConsultationCategorySummaryModel> {
    layout: string;
    anamnesis: string;
    observations: string;
    treatments: string;
    examDefinitions: ConsultationCategoryExamDefinitionModel[] = [];
    treatmentDefinitions: ConsultationCategoryTreatmentDefinitionModel[] = [];
}
